interface ButtonProps {
  type: 'primary' | 'secondary' | 'round' | 'empty' | 'arrow' | 'social'
  text: string
  icon?: string
  disabled?: boolean
  alwaysAddAction?: boolean
  action: () => void
}

const Button: React.FC<ButtonProps> = ({ type, disabled, text, icon, alwaysAddAction, action }) => {
  const renderIcon = () => {
    if (icon && icon !== 'google' && icon !== 'facebook') {
      return <i className={`icon icon--${icon}`}></i>
    } else if (icon === 'google' || icon === 'facebook') {
      return <i className={`icon--${icon}`}></i>
    }
    return null
  }

  return (
    <button
      className={`btn btn--${type} ${disabled ? 'disabled' : ''}`}
      onClick={(disabled && !alwaysAddAction) ? undefined : action}>
      {renderIcon()}
      {text}
    </button>
  )
}

export default Button